<template>
    <section class="search">
        <SearchHeader :searchList="searchList" :searchQuery="query"></SearchHeader>
        <Spinner v-if="loading"></Spinner>
        <SearchNoResults v-else-if="noResults"></SearchNoResults>
        <SearchResults v-else :searchList="searchList" :itemsPerPage="itemsPerPage" :itemsPage="itemsPage"></SearchResults>
    </section>
</template>

<script>
import axios from "axios";
import SearchHeader from "./SearchHeader.vue";
import SearchResults from "./SearchResults.vue";
import SearchNoResults from "./SearchNoResults.vue";
import Spinner from "../elements/Spinner.vue";
import globalDataLayer from '../../mixins/globalDataLayer';

export default {
    name: "Search",
    components: {
        SearchHeader,
        SearchResults,
        SearchNoResults,
        Spinner
    },
    data() {
        return {
            URL_SEARCH: '/api/krainaabc/search?device=www&query=',
            loading: true,
            noResults: false,
            searchList: [],
            itemsPerPage: 10
        };
    },
    mixins: [globalDataLayer],
    watch: {
        '$route.query.query': {
            handler: function(routeQuery) {
                if(routeQuery) {
                    this.getSearch(routeQuery);

                    window.gemius_event(
                        '_view_',
                        this.gemiusIdentifier,
                        `SEARCH_VALUE=${this.query}`
                    );                     
                }
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        query() {
            return this.$route.query.query;
        },
        itemsPage() {
            if(this.$route.query.page) {
                return parseInt(this.$route.query.page);
            }
            return 1;
        },
        gemiusIdentifier() {
            return this.$store.getters.getGemiusIdentifier;
        }
    },
    methods: {
        getSearch(query) {
            this.searchList = [];
            this.loading = true;

            let endpoint = `${this.URL_SEARCH}${query}`;

            if(this.itemsPage) {
                endpoint = endpoint + `&limit=${this.itemsPerPage}&page=${this.itemsPage}`;
            }

            axios.get(endpoint).then((response) => {
                if (response.status === 200) {
                    if(response.data.data && response.data.data.items && response.data.data.items.length > 0) {
                        this.searchList = response.data.data;
                        this.searchEvent(query, this.searchList.total_count || 0);
                        this.noResults = false;
                    } else {
                        this.searchEvent(query, 0);
                        this.noResults = true;
                    }
                    this.loading = false;
                } else {
                    this.noResults = true;
                    this.loading = false;
                }
            });
        }
    }
};
</script>